import type { PortalWidget } from "@entrilia/shared/api/portalWidgetsTypes";
import useFetch from "@entrilia/shared/hooks/useFetch";
import { api } from "../../api/client";
import useClientContext from "../../contexts/useClientContext";
import { pageRoutes } from "../../routes";
import WidgetCardWrapper from "../widgets/WidgetCardWrapper";
import ViewAllWidgetButton from "../widgets/ViewAllWidgetButton";
import WidgetHeader from "../widgets/WidgetHeader";
import NewsWidgetContent from "./NewsWidgetContent";

interface Props {
  widgetSettings: PortalWidget;
}

const getLatestNews = (signal?: AbortSignal) => api.investorCommunications.search({ paging: { size: 1 } }, signal);

const NewsWidget = ({ widgetSettings }: Props) => {
  const { clientCode } = useClientContext();
  const [newsPage, fetchError] = useFetch(getLatestNews);

  const newsPagePath = `/${clientCode}/${pageRoutes.news}`;

  return (
    <WidgetCardWrapper fitContent actions={<ViewAllWidgetButton to={newsPagePath} />}>
      <WidgetHeader name={widgetSettings.name} />
      <NewsWidgetContent
        latestNews={newsPage?.items[0]}
        loading={newsPage === undefined}
        fetchError={fetchError}
        newsPagePath={newsPagePath}
      />
    </WidgetCardWrapper>
  );
};

export default NewsWidget;
